






























import { Vue, Component, Watch } from 'vue-property-decorator';
import ContractInfoTabControl from './contract-info-tab-index';

const ALL_TABS: Array<{ label: string, slot: string }> = [
  { label: ContractInfoTabControl.ITENS, slot: 'items' },
  { label: ContractInfoTabControl.INSTANCIAS, slot: 'instances' },
  { label: ContractInfoTabControl.REAJUSTE, slot: 'readjustment' },
  { label: ContractInfoTabControl.DESCONTOS, slot: 'discount' },
  { label: ContractInfoTabControl.ACRESCIMOS, slot: 'fee' },
  { label: ContractInfoTabControl.LINKS, slot: 'links' },
  { label: ContractInfoTabControl.INFORMACOES_ADICIONAIS, slot: 'additional-info' },
  { label: ContractInfoTabControl.HISTORICO, slot: 'history' },
  { label: ContractInfoTabControl.SOLICITAR_CANCELAMENTO, slot: 'cancellation-data' },
];

@Component
export default class TabComponent extends Vue {
  tab: number = 0;

  tabItems: Array<{ label: string, slot: string }> = [];

  selectTab(tab: number) {
    this.tab = tab;
    this.$emit('selectTab', this.tab);
    this.$emit('selectTabControl', this.tabItems[this.tab].label);
  }

  created() {
    this.defineTabItems();
  }

  get visibleTabItems(): Array<{ label: string, slot: string }> {
    return ALL_TABS;
  }

  defineTabItems() {
    this.tabItems = this.visibleTabItems
  }
}

